module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.5014568.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/open-sans/OpenSans-Bold.ttf
// module id = Kv9M
// module chunks = 11